import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=968ad108"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
import style0 from "./Header.vue?vue&type=style&index=0&id=968ad108&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WrapFlex: require('/app/nuxt/components/WrapFlex.vue').default,WrapComponents: require('/app/nuxt/components/WrapComponents.vue').default,Header: require('/app/nuxt/components/Header.vue').default})
